import React from 'react';
import Link from 'gatsby-link';
import Imgix from 'react-imgix';
import Icon from '../Icon';
import { ButtonTextNoLink } from '../Buttons';
import { formatDate, endSlash } from '../../util/helperFunctions';

const FeedQueryDown = ({ page, className, secondaryLink }) => {
  if (!page) return null;

  return (
    <div
      className={`feed-query-block ${className} flex flex-column flex-row-m mw-1060 center-m relative`}
    >
      <Link
        to={endSlash(page.route)}
        className="feed-query-block__info ease-out--l bg-peach dark pa2 pa3-l mt2-m mt3-l ml2 ml0-m relative flex flex-column justify-between"
      >
        <div>
          <p className="h-2--small h-2-l mb1">Latest:</p>
          <p className="h-4 ttu h-3--l mbo">{page.title}</p>
        </div>
        <div className="flex justify-between">
          <div className="flex justify-start items-center">
            <Icon path="icon-18-news" width="18" height="15" className="mr1" />
            <ButtonTextNoLink text="Read More" className="o-40 dark" />
          </div>
          <p className="flex items-center mb0 h-6 dark">
            {page.publishedDate && formatDate(page.publishedDate)}
          </p>
        </div>
      </Link>
      <Link
        to={endSlash(page.route)}
        className="feed-query-block__image ease-out--l mr2 mr2 mr0-m bg-grey2 flex"
      >
        {page.abstractPhoto && (
          <div className="overflow-hidden h-100 w-100">
            <Imgix
              type="img"
              src={endSlash(page.abstractPhoto.url)}
              className="h-100 w-100 image-cover ease-out--l mb0"
              imgixParams={{
                'max-h': 530,
                'max-w': 530,
                'fp-x': page.abstractPhotoFocalPointX,
                'fp-y': page.abstractPhotoFocalPointY,
                crop: 'focalpoint',
                fit: 'crop',
                auto: ['compress']
              }}
              htmlAttributes={{
                alt: page.abstractPhotoAltText
              }}
            />
          </div>
        )}
      </Link>
      {secondaryLink && (
        <Link
          to={endSlash(secondaryLink.route)}
          className="feed-query-block__secondary-link mt2 ph2 ph0-m mt0-m absolute-m left-0 h-5 tr-m grey1 ttu flex"
        >
          <p className="mr1 grey1 ttu mb0">{secondaryLink.title}</p>
          <Icon path="arrow-right" width="32" height="18" className="" />
        </Link>
      )}
    </div>
  );
};

export default FeedQueryDown;



// WEBPACK FOOTER //
// ./src/components/PageHelpers/FeedQueryDown.js